export const Category = {
  transportation: 0,
  clothing: 0,
  donations_and_gifts: 0,
  entertainment: 0,
  food: 0,
  gadgets_and_appliances: 0,
  internet_and_subscriptions: 0,
  loans: 0,
  repairs_and_maintenance: 0,
  telephone: 0,
  utility: 0,
  miscellaneous: 0,
};
